$(document).ready(() => {
  if (!$('#branchPage').length) {
    return
  }
  const branch = {
    getGeoLocation: () => {
      if (isMobile) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            branch.calculateDistance,
            () => {
              $('.distance').hide()
            }
          )
        } else {
          $('.distance').hide()
        }
      }
    },
    calculateDistance: (position) => {
      $('.distance').show()
      const distanceSelector = $('#distance-number')

      const currentLatitude = position.coords.latitude
      const currentLongitude = position.coords.longitude

      const destinationLatitude = $('.distance').data('latitude')
      const destinationLongitude = $('.distance').data('longitude')

      if (
        currentLatitude == destinationLatitude &&
        currentLongitude == destinationLongitude
      ) {
        distanceSelector.text('0.0')
        return
      }

      const radlat1 = (Math.PI * currentLatitude) / 180
      const radlat2 = (Math.PI * destinationLatitude) / 180
      const theta = currentLongitude - destinationLongitude
      const radtheta = (Math.PI * theta) / 180

      let dist =
        Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)

      if (dist > 1) {
        dist = 1
      }

      dist = Math.acos(dist)
      dist = (dist * 180) / Math.PI
      dist = dist * 60 * 1.1515
      dist = dist * 1.609344

      dist = Number(dist)
      distanceSelector.text(dist.toFixed(2))
    },
    addSeparatortoNumbers: () => {
      const phoneNumber = $('.phone').data('tel')
      const faxNumber = $('.fax').data('fax')

      $('.phone').text(branch.addSeparator(phoneNumber))
      $('.fax').text(branch.addSeparator(faxNumber))
    },

    addSeparator: (number) => {
      if (number.length == 9) {
        return number.slice(0, 2) + '-' + number.slice(2)
      } else if (number.length == 10) {
        return number.slice(0, 3) + '-' + number.slice(3)
      } else {
        return number
      }
    },
  }

  setTimeout(() => {
    branch.getGeoLocation()
    branch.addSeparatortoNumbers()
  })
})
